import { combineReducers } from 'redux';
import appDisplay from './appDisplay';
import attendance from './attendance';
import courseProgress from './courseProgress';
import courseRegistrations from './courseRegistrations';
import courses from './courses';
import jobs from './jobs';
import liveParticipants from './liveParticipants';
import magdalaCommunities from './magdalaCommunities';
import magdalaCommunityUpdates from './magdalaCommunityUpdates';
import magdalaRegistrations from './magdalaRegistrations';
import marketingTags from './marketingTags';
import notifications from './notifications';
import profiles from './profiles';
import profileUpdates from './profileUpdates';
import user from './user';
import watchlist from './watchlistManager';
import watchlistWebSocket from './liveBoard';

const rootReducer = combineReducers({
  appDisplay,
  attendance,
  courseProgress,
  courseRegistrations,
  courses,
  jobs,
  liveParticipants,
  magdalaCommunities,
  magdalaCommunityUpdates,
  magdalaRegistrations,
  marketingTags,
  notifications,
  profiles,
  profileUpdates,
  user,
  watchlist,
  watchlistWebSocket,
});

export default rootReducer;